var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIconIntro2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mainpage_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 174,
    height: 87,
    viewBox: "0 0 174 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_321",
    "data-name": "\\uD0C0\\uC6D0 321",
    cx: 3,
    cy: 3,
    r: 3,
    fill: "#ffc019"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_325",
    "data-name": "\\uD0C0\\uC6D0 325",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(24)",
    fill: "#ffc019"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_329",
    "data-name": "\\uD0C0\\uC6D0 329",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(48)",
    fill: "#ffc019"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_333",
    "data-name": "\\uD0C0\\uC6D0 333",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(72)",
    fill: "#ffc019"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_337",
    "data-name": "\\uD0C0\\uC6D0 337",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(96)",
    fill: "#ffc019"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_341",
    "data-name": "\\uD0C0\\uC6D0 341",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(120)",
    fill: "#ffc019"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_345",
    "data-name": "\\uD0C0\\uC6D0 345",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(144)",
    fill: "#ffc019"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_349",
    "data-name": "\\uD0C0\\uC6D0 349",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(168)",
    fill: "#ffc019"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_322",
    "data-name": "\\uD0C0\\uC6D0 322",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(0 21)",
    fill: "#ffc019"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_326",
    "data-name": "\\uD0C0\\uC6D0 326",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(24 21)",
    fill: "#ffc019"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_330",
    "data-name": "\\uD0C0\\uC6D0 330",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(48 21)",
    fill: "#ffc019"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_334",
    "data-name": "\\uD0C0\\uC6D0 334",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(72 21)",
    fill: "#ffc019"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_338",
    "data-name": "\\uD0C0\\uC6D0 338",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(96 21)",
    fill: "#ffc019"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_342",
    "data-name": "\\uD0C0\\uC6D0 342",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(120 21)",
    fill: "#ffc019"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_346",
    "data-name": "\\uD0C0\\uC6D0 346",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(144 21)",
    fill: "#ffc019"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_350",
    "data-name": "\\uD0C0\\uC6D0 350",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(168 21)",
    fill: "#ffc019"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_323",
    "data-name": "\\uD0C0\\uC6D0 323",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(0 42)",
    fill: "#ffc019"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_327",
    "data-name": "\\uD0C0\\uC6D0 327",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(24 42)",
    fill: "#ffc019"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_331",
    "data-name": "\\uD0C0\\uC6D0 331",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(48 42)",
    fill: "#ffc019"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_335",
    "data-name": "\\uD0C0\\uC6D0 335",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(72 42)",
    fill: "#ffc019"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_339",
    "data-name": "\\uD0C0\\uC6D0 339",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(96 42)",
    fill: "#ffc019"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_343",
    "data-name": "\\uD0C0\\uC6D0 343",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(120 42)",
    fill: "#ffc019"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_347",
    "data-name": "\\uD0C0\\uC6D0 347",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(144 42)",
    fill: "#ffc019"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_351",
    "data-name": "\\uD0C0\\uC6D0 351",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(168 42)",
    fill: "#ffc019"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_324",
    "data-name": "\\uD0C0\\uC6D0 324",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(0 63)",
    fill: "#ffc019"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_328",
    "data-name": "\\uD0C0\\uC6D0 328",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(24 63)",
    fill: "#ffc019"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_332",
    "data-name": "\\uD0C0\\uC6D0 332",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(48 63)",
    fill: "#ffc019"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_336",
    "data-name": "\\uD0C0\\uC6D0 336",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(72 63)",
    fill: "#ffc019"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_340",
    "data-name": "\\uD0C0\\uC6D0 340",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(96 63)",
    fill: "#ffc019"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_344",
    "data-name": "\\uD0C0\\uC6D0 344",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(120 63)",
    fill: "#ffc019"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_348",
    "data-name": "\\uD0C0\\uC6D0 348",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(144 81)",
    fill: "#ffc019"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconIntro2);
export default __webpack_public_path__ + "static/media/navIconIntro2.3213f2cc68dada7251e46b26fa1ada83.svg";
export { ForwardRef as ReactComponent };